import ErrorComponent from './Error';
import NoRecordComponent from './NoRecords';

export { ErrorComponent, NoRecordComponent };
